import { render, staticRenderFns } from "./Controller.vue?vue&type=template&id=362f0019&scoped=true&"
import script from "./Controller.vue?vue&type=script&lang=js&"
export * from "./Controller.vue?vue&type=script&lang=js&"
import style0 from "./Controller.vue?vue&type=style&index=0&id=362f0019&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362f0019",
  null
  
)

export default component.exports